/** A Stripe unit amount (cents) as a dollar string: $2,500 or $12.50. */
export function formatPrice(unitAmount: number, currency: string): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    // Whole-dollar amounts render clean; an amount with cents must show
    // them — rounding would misstate what checkout charges.
    maximumFractionDigits: unitAmount % 100 === 0 ? 0 : 2,
  }).format(unitAmount / 100)
}
